var _defs, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlug(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "plugNavGradient",
    gradientTransform: "rotate(300)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "25%",
    stopColor: "#F8A305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85%",
    stopColor: "#F51504"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "navigation__plug-fill",
    x: 6,
    y: 2,
    width: 3,
    height: 7,
    rx: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "navigation__plug-fill",
    x: 12,
    y: 2,
    width: 3,
    height: 7,
    rx: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "navigation__plug-fill",
    x: 2.5,
    y: 8,
    width: 16,
    height: 10,
    rx: 3.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlug);
export default __webpack_public_path__ + "static/media/plug.f1a09f11f4f98b7ff0caa7e7b6435dc2.svg";
export { ForwardRef as ReactComponent };